import * as React from 'react';
import UploadControl from '../../../../../../../components/forms/UploadControl';
import PictureModel from '../../../../../model/picture/PictureModel';
import { useTranslation } from 'react-i18next';
import IframeServiceInjector from '../../../../../services/injectors/IframeServiceInjector';
import FrameEventMessanger from '../../../../../services/frames/FrameEventMessanger';
import { PICTURE_CHANGE } from '../../../../../consts/events';

interface FCProps {}

const UploadImageTab: React.FC<FCProps> = ({}) => {
  const { t } = useTranslation();

  return (
    <div>
      <UploadControl
        uploadTextButton={t('Upload image')}
        onChange={(info, previewUrl: string) => {
          PictureModel.addPicture({
            ObjectURL: info,
            PresignedUrl: previewUrl
          });

          IframeServiceInjector.getService<FrameEventMessanger>(
            'FrameEventMessanger'
          ).sendMessage(PICTURE_CHANGE, {
            elementId: PictureModel.pictureEditModalOpened,
            imgUrl: previewUrl
          });

          PictureModel.closePictureEditModal();
        }}
      />
    </div>
  );
};

export default UploadImageTab;
